import { createRouter, createWebHistory } from 'vue-router'
// 引入搜索组件
import SearchComponent from '../components/SearchComponent.vue'

const routes = [
  {
    path: '/',
    name: 'searchByTitleAndContent',
    component: SearchComponent
  },
  {
    path: '/detail/:id',  // 通过路径参数传递法律ID
    name: 'LawDetail',
    component: () => import('@/views/LawDetail.vue')  // 加载详情页组件
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
